import { ErrorMessage } from "@hookform/error-message";
import { Typography } from "@material-ui/core";
import React from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";

import EmailTemplatePicker from "./EmailTemplatePicker";

type FormEmailTemplatePickerProps = {
  control: Control;
  errors: FieldErrors;
  name: string;
  label?: string;
  className?: string;
  defaultValue?: string;
  isRequired?: boolean;
  disableClearable: boolean;
};

const FormEmailTemplatePicker: React.FC<FormEmailTemplatePickerProps> = ({
  errors,
  defaultValue,
  control,
  name = "emailTemplateId",
  className = "",
  label = "Template",
  isRequired = true,
  disableClearable,
}) => (
  <div className={className}>
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
      }}
      defaultValue={defaultValue}
      render={({ field }) => (
        <EmailTemplatePicker
          label={label}
          value={field.value}
          onChange={field.onChange}
          error={!!errors[name]}
          disableClearable={disableClearable}
        />
      )}
    />
    <Typography variant="subtitle1" color="error">
      <ErrorMessage
        errors={errors}
        name={name}
        message="Please select a Email Template"
      />
    </Typography>
  </div>
);

export default FormEmailTemplatePicker;
